import React from 'react';
import { Box, Typography, Container, Paper, Divider } from '@mui/material';

const Refund = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Refund and Cancellation Policy
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Last Updated: April 11, 2026
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          1. Security Deposit
        </Typography>
        <Typography variant="body1" paragraph>
          The security deposit is fully refundable upon vacating the room, subject to a clearance of all dues and no damage to hostel property.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          2. Monthly Rent
        </Typography>
        <Typography variant="body1" paragraph>
          Monthly rent once paid is non-refundable. If you vacate in the middle of a month, the rent for that month will not be pro-rated or refunded.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          3. Process
        </Typography>
        <Typography variant="body1" paragraph>
          Refunds will be processed within 7-10 working days via the original payment method (PhonePe) after a formal vacation request is approved by the Warden.
        </Typography>

        <Divider sx={{ my: 4 }} />
        <Typography variant="body2" color="text.secondary" align="center">
          For refund status, please visit the Payments section of your dashboard.
        </Typography>
      </Paper>
    </Container>
  );
};

export default Refund;
